module.exports = __webpack_public_path__ + "static/img/bystage_06.596601b1.svg";